import _ from 'lodash';

export default function hasBackOfficeAccess(state) {
  const accountRoles = _.get(state, 'accountRoles.accountRoles');
  const hasHQUserRole = !!_.find(accountRoles, ['role', 'hq_user']);
  const hasHQAdminRole = !!_.find(accountRoles, ['role', 'hq_admin']);
  return hasHQAdminRole || hasHQUserRole;
}
